{
  "actions": "Дії",
  "actionsAvailable": "Доступні дії.",
  "clearSelection": "Очистити вибір",
  "selected": "{count, plural, =0 {Нічого не вибрано} other {Вибрано: #}}",
  "selectedAll": "Усе вибрано"
}
